import { useState } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { NOTIFICATIONS_API_URL } from '../api/notifications-api';
import { useRevalidateModules } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
export interface GetNotificationLinkResponse {
  link: string;
}
export const useNotificationsActions = () => {
  const {
    fetcher: postFetcher
  } = useFetch<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post
  });
  const {
    fetcher: linkFetcher
  } = useFetch<RequestMethodsEnum.get, GetNotificationLinkResponse>({
    method: RequestMethodsEnum.get
  });
  const {
    revalidateModules
  } = useRevalidateModules();

  // owned locally rather than taken from the fetcher: the same fetcher marks single notifications
  // too, and the flag has to stay raised through the revalidation that follows the POST
  const [isMarkingAllAsRead, setIsMarkingAllAsRead] = useState(false);
  const markAllNotificationsAsRead = async () => {
    try {
      setIsMarkingAllAsRead(true);
      await postFetcher(`${NOTIFICATIONS_API_URL}/notifications/mark-all-as-read`);
      await revalidateModules([RequestModuleEnum.Notifications]);
    } finally {
      setIsMarkingAllAsRead(false);
    }
  };
  const markNotificationAsRead = async (id: string) => {
    await postFetcher(`${NOTIFICATIONS_API_URL}/notifications/${id}/mark-as-read`);
    await revalidateModules([RequestModuleEnum.Notifications]);
  };
  const getNotificationLink = async (id_0: string) => {
    const data = await linkFetcher(`${NOTIFICATIONS_API_URL}/notifications/${id_0}`);
    await revalidateModules([RequestModuleEnum.Notifications]);
    return data;
  };
  return {
    isMarkingAllAsRead,
    markAllNotificationsAsRead,
    markNotificationAsRead,
    getNotificationLink
  };
};